const routeConfigs = [];

export default routeConfigs;
